import React from 'react';
import { PRICING } from '../pricing';
import QuizIcon from '@mui/icons-material/Quiz';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import SmartToyIcon from '@mui/icons-material/SmartToy';

export const aiEngineering = {
    title: "AI Engineering",
    icon: <SmartToyIcon sx={{ fontSize: 40, color: '#ef4444' }} />,
    description: "Build production-ready AI apps using LLMs and Agents.",
    price: PRICING.aiEngineering.price,
    mrp: PRICING.aiEngineering.mrp,
    topics: [
      {
        id: "llm_apps",
        title: "Building LLM Apps",
        desc: "Prompt Engineering, RAG, and Vector DBs.",
        badge: "Advanced",
        fileUrl: "/documents/ai/ai_llm_apps.md",
        icon: <RocketLaunchIcon />,
        group: "LLMs",
        problems: []
      },
      {
        id: "ai_engineering_quizzes",
        title: "AI Engineering Quizzes",
        desc: "Consolidated assessment for AI engineering concepts.",
        badge: "Quiz",
        icon: <QuizIcon />,
        group: "Final Assessment",
        problems: [
          { id: "quiz_llm_apps", title: "Building LLM Apps Quiz", badge: "Quiz", fileUrl: "/documents/quizzes/quiz_llm_apps.md" }
        ]
      }
    ]
  };
